let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("drtBk")).then(() => parcelRequire('3nU2q'));